"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRemoveMagicZoomFromDOM = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = require("react");
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
var useRemoveMagicZoomFromDOM = function useRemoveMagicZoomFromDOM() {
  (0, _react.useEffect)(function () {
    return function () {
      var _document$documentEle;
      // html tag
      (_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.classList.remove('mac-magic', 'svg-magic');
      // css section
      var magiczoomResetCss = document.getElementById('magiczoom-reset-css');
      var mzRuntimeCss = document.getElementById('mz-runtime-css');
      var magic360CssReset = document.getElementById('magic360-css-reset');
      magiczoomResetCss === null || magiczoomResetCss === void 0 ? void 0 : magiczoomResetCss.remove();
      mzRuntimeCss === null || mzRuntimeCss === void 0 ? void 0 : mzRuntimeCss.remove();
      magic360CssReset === null || magic360CssReset === void 0 ? void 0 : magic360CssReset.remove();

      // bottom - before </body>
      var magicHiddenWrappers = document.getElementsByClassName('magic-hidden-wrapper');
      var m360TmpHdnConts = document.getElementsByClassName('m360-tmp-hdn-cont');
      var magicFullscreen = document.getElementsByClassName('Magic360-fullscreen');
      var magicTemporaryImages = document.getElementsByClassName('magic-temporary-img');
      var domElementsToRemove = [].concat((0, _toConsumableArray2["default"])(magicHiddenWrappers), (0, _toConsumableArray2["default"])(m360TmpHdnConts), (0, _toConsumableArray2["default"])(magicFullscreen), (0, _toConsumableArray2["default"])(magicTemporaryImages));
      var _iterator = _createForOfIteratorHelper(domElementsToRemove),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var element = _step.value;
          element.remove();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };
  }, []);
};
exports.useRemoveMagicZoomFromDOM = useRemoveMagicZoomFromDOM;